const currentYear = new Date().getFullYear();
const bottomItems = [
  {
    label: 'FAQ & Help',
    to: 'https://linktivityb2b.zendesk.com/hc/en-us'
  },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: '特定商取引法に基づく表記', to: '/legal-notice' },
  { label: `©${currentYear} Linktivity` }
];

export default bottomItems;
